import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReembolsoDespesasListComponent } from './reembolso-despesas-list/reembolso-despesas-list.component';

const routes: Routes = [
    { path: '', component: ReembolsoDespesasListComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ReembolsoDespesasRoutingModule { }
